<style lang="scss" scoped>
.query-form-div {
  padding: 12px;
}

.body-div {
  padding: 12px;
}

.pagination-div {
  padding: 12px;
  text-align: right;
}

.handle-div {
  padding: 12px;
  text-align: right;
}
</style>
<template>
  <div v-loading="allLoading" element-loading-text="数据加载中...">
    <div class="query-form-div">
      <el-form :inline="true" :model="qForm">
        <el-form-item label="登录账号">
          <el-input v-model="qForm.LoginName" placeholder="登录账号" size="small" />
        </el-form-item>

        <el-form-item label="账号类型">
          <el-select v-model="qForm.AccountType" size="small">
            <el-option label="全部" value="" />
            <el-option label="超级管理员" value="0" />
            <el-option label="后台管理员" value="2" />
            <el-option label="裁判账号" value="1" />
          </el-select>
        </el-form-item>

        <el-form-item label="账号状态">
          <el-select v-model="qForm.IsLock" size="small">
            <el-option label="全部" value="" />
            <el-option label="正常" value="0" />
            <el-option label="锁定" value="1" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="allLoading" @click="query(true)"
            size="small">查询</el-button>
          <el-button icon="el-icon-plus" size="small" @click="userRowEdit">添加账号</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="body-div">
      <el-table :data="tb.data" style="width: 100%" stripe size="mini" border>
        <el-table-column label="登录账号" prop="LoginName" />
        <el-table-column label="手机号" prop="AccPhone" />
        <el-table-column label="所属省份" prop="ProvinceName" />

        <el-table-column label="账号类型" align="center" width="300">

          <template v-slot="scope">
            <span v-if="scope.row.AccountType == 0">超级管理员</span>
            <span v-if="scope.row.AccountType == 2">后台管理员</span>
            <span v-if="scope.row.AccountType == 1">裁判账号</span>
          </template>
        </el-table-column>
        <el-table-column label="用户状态" align="center" width="300">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.IsLock == 0 ? 'success' : 'danger'" disable-transitions>{{
              scope.row.IsLock == 1 ?
                "锁定" : "正常" }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.AccountType == 2" size="mini" icon="el-icon-yonghuquanxian" circle
              @click="permissionRowEdit(scope.row)"></el-button> -->
              <el-tooltip size="mini" content="权限设置" placement="bottom" effect="light">
                <el-button size="mini" @click="permissionRowEdit(scope.row)" icon="el-icon-yonghuquanxian" circle></el-button>
              </el-tooltip>
            <el-button size="mini" icon="el-icon-edit" circle @click="userRowEdit(scope.row)"></el-button>
            <el-button size="mini" circle :type="scope.row.IsLock == 1 ? 'success' : 'warning'"
              :icon="scope.row.IsLock == 0 ? 'el-icon-lock' : 'el-icon-unlock'"
              @click.native.prevent="changeStatus(scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-div">
      <el-pagination background :current-page="tb.pi" :page-sizes="[10, 20, 40, 60, 100]" :page-size="tb.ps"
        layout="total, sizes, prev, pager, next, jumper" :total="tb.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <el-dialog :title="(dgType == 1 ? '编辑' : '新增') + '系统用户信息'" :visible.sync="dgUserInfoShow" width="600px">
      <div v-loading="dgUserInfoLoading">
        <el-form ref="dgUserInfo" :model="dgUserInfo" :rules="dgUserInfoRules" label-width="100px">
          <el-form-item label="登录账号" prop="LoginName">
            <el-input v-model="dgUserInfo.LoginName" :disabled="dgType == 1" size="small" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="dgUserInfo.AccPhone" size="small" />
          </el-form-item>
          <el-form-item label="所属省份">
            <el-select v-model="dgUserInfo.Province" size="small" clearable :filterable="true">
              <el-option v-for="item in provinces" :key="item.ConstValue" :label="item.ConstShowName" :value="item.ConstValue" />
            </el-select>

          </el-form-item>
          <el-form-item label="账号类型" prop="AccountType">
            <el-radio v-model="dgUserInfo.AccountType" :label="0">超级管理员</el-radio>
            <el-radio v-model="dgUserInfo.AccountType" :label="2">后台管理员</el-radio>
            <el-radio v-model="dgUserInfo.AccountType" :label="1">裁判账号</el-radio>
          </el-form-item>
          <!-- <el-form-item label="姓名" prop="Name">
              <el-input v-model="dgUserInfo.Name" />
            </el-form-item> -->
          <el-form-item v-if="dgType == 1">
            <el-button v-if="!dgIsEditPwd" size="small" @click="isEditPwd">修改密码</el-button>
          </el-form-item>
          <el-form-item v-if="dgType == 0 || dgIsEditPwd" label="密码" prop="LoginPwd">
            <el-input v-model="dgUserInfo.LoginPwd" show-password size="small" />
          </el-form-item>
          <el-form-item v-if="dgType == 0 || dgIsEditPwd" label="确认密码" prop="ConfirmPwd">
            <el-input v-model="dgUserInfo.ConfirmPwd" show-password size="small" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="dgUserInfoLoading" @click="commitUserinfoDetail">确
          定</el-button>
        <el-button type="info" size="small" :loading="dgUserInfoLoading" @click="dgUserInfoShow = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="权限设置" :visible.sync="dgPermissionShow" width="600px">
      <div>
        <el-form label-width="100px">
          <el-form-item label="登录账号">
            {{ permissionForm.AccountName }}
          </el-form-item>
          <el-form-item label="权限">
            <el-tree :data="permissionTree" node-key="id" :props="defaultProps" ref="tree" show-checkbox
              @check-change="permissionTreeCheckChange">
            </el-tree>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="dgPermissionLoading" @click="submitPermissionForm">确
          定</el-button>
        <el-button type="info" size="small" :loading="dgPermissionLoading" @click="dgPermissionShow = false">取
          消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserInfoService from "@/request-server/request-services/userinfo-services.js";
import SystemService from "@/request-server/request-services/system-services.js";


export default {
  data() {
    return {
      allLoading: false,
      qForm: {
        LoginName: "",
        IsLock: "",
        AccountType: ''
      },
      roleList: [],
      tb: {
        pi: 1,
        ps: 10,
        total: 0,
        data: [],
      },
      dgUserInfo: {
        AccountId: "",
        LoginName: "",
        LoginPwd: "",
        ConfirmPwd: '',
        Province: '',
        OriginAccPhone: ''
      },
      dgUserInfoRules: {
        LoginName: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        AccountType: [
          {
            required: true,
            message: "请选择账号类型",
            trigger: "blur",
          },
        ],
        Province: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur",
          },
        ],

        LoginPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length < 6) {
                callback(new Error("密码长度不能小于6位!"));
              } else callback();
            },
            trigger: "blur",
          },
        ],
        ConfirmPwd: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value != this.dgUserInfo.LoginPwd) {
                callback(new Error("两次输入密码不一致!"));
              } else callback();
            },
            trigger: "blur",
          },
        ],

      },
      dgType: 0, // 0新增，1编辑
      dgUserInfoShow: false,
      dgUserInfoLoading: false,
      dgIsEditPwd: false,
      dgPermissionShow: false,
      dgPermissionLoading: false,
      permissionTree: [],
      permissionForm: {
        AccountId: '',
        AccountName: '',
        Permissions: []
      },
      defaultProps: {
        id: 'id',//标识每个结点
        label: 'label',//结点的文本展示
        children: 'children'//结点的子节点
      },
      provinces:[]
    };
  },
  created() {
    this.query();
    this.getProvinces();

  },
  methods: {

    query(isInit) {
      if (isInit) {
        this.tb.pi = 1;
      }
      const qParams = {
        PageIndex: this.tb.pi,
        PageSize: this.tb.ps,
        Where: {
          LoginName: this.qForm.LoginName,
          IsLock: this.qForm.IsLock,
          AccountType: this.qForm.AccountType
        },
      };
      this.allLoading = true;
      UserInfoService.selectAccountList(qParams).then((res) => {
        this.allLoading = false;
        if (res.code == 0) {
          this.tb.data = res.data.Data;
          this.tb.total = res.data.Total;
        }
      });
    },
    handleSizeChange(val) {
      this.tb.ps = val;
      this.query(true);
    },
    handleCurrentChange(val) {
      this.tb.pi = val;
      this.query(false);
    },
    userRowEdit(row) {
      this.dgUserInfo = {
        AccountId: "",
        LoginName: "",
        LoginPwd: "",
        ConfirmPwd: "",
        AccPhone: '',
        OriginAccPhone: '',
        AccountType: 0,
      };

      if (row.AccountId) {
        this.dgType = 1;
        this.dgUserInfo.AccountId = row.AccountId;
        this.dgUserInfo.LoginName = row.LoginName;
        this.dgUserInfo.AccPhone = row.AccPhone;
        this.dgUserInfo.OriginAccPhone = row.AccPhone;
        this.dgUserInfo.LoginPwd = row.LoginPwd;
        this.dgUserInfo.AccountType = row.AccountType;
        this.dgUserInfo.Province = row.Province;

        this.dgIsEditPwd = false;
      } else {
        this.dgType = 0;
      }
      this.dgUserInfoShow = true;
    },
    getProvinces(){
      SystemService.getConstantByType({type:'省份'}).then((res) => {
        if (res.code == 0) {
          this.provinces = res.data;
        }
      });
    },

    permissionRowEdit(row) {
      this.permissionForm.AccountId = row.AccountId;
      this.permissionForm.AccountName = row.LoginName;
      this.permissionForm.Permissions = row.Permissions;
      console.log(this.permissionForm.Permissions)
      if (this.permissionTree == null || this.permissionTree.length == 0) {
        this.initPermissionTree();
      }
      this.dgPermissionShow = true;
      setTimeout(() => {
        this.$refs.tree.setCheckedKeys(this.permissionForm.Permissions);
      }, 1000);

    },
    initPermissionTree() {
      UserInfoService.getPermissionTree().then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          this.permissionTree = res.data;
        }
      });
    },
    submitPermissionForm() {
      this.dgPermissionLoading = true;
      UserInfoService.setAccountPermission(this.permissionForm)
        .then((res) => {
          this.dgPermissionLoading = false;
          if (res.code == 0) {
            this.$message.success(res.data);
            this.$refs.tree.setCheckedKeys([]);
            this.dgPermissionShow = false;
            this.query(true);
          }
        })
        .finally(() => (this.dgPermissioLoading = false));
    },

    permissionTreeCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      console.log(this.$refs.tree.getCheckedKeys());
      this.permissionForm.Permissions = this.$refs.tree.getCheckedKeys();
    },

    changeStatus(row) {
      this.$confirm(
        `确定要${row.IsLock == 0 ? "锁定" : "解锁"}该账号吗？`,
        "提示"
      ).then(() => {
        UserInfoService.lockOrUnlock({ id: row.AccountId }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.data);
            this.query(false);
          }
        });
      });
    },
    commitUserinfoDetail() {
      this.$refs["dgUserInfo"].validate((valid) => {
        if (valid) {
          console.log(this.dgUserInfo)
          if (this.dgUserInfo.AccPhone != '' && this.dgUserInfo.AccPhone != this.dgUserInfo.OriginAccPhone) {
            //验证手机号格式
            const phoneRegex = /^1[3-9]\d{9}$/;
            if (!phoneRegex.test(this.dgUserInfo.AccPhone)) {
              this.$message.warning('手机号格式不正确');
              return;
            }
          }
          this.dgUserInfoLoading = true;
          UserInfoService.editAccount(this.dgUserInfo)
            .then((res) => {
              this.dgUserInfoLoading = false;
              if (res.code == 0) {
                this.$message.success(res.data);
                this.dgUserInfo = {
                  AccountId: "",
                  LoginName: "",
                  LoginPwd: "",
                  ConfirmPwd: "",
                  AccountType: 0,
                };
                this.dgUserInfoShow = false;
                this.query(true);
              }
            })
            .finally(() => (this.dgUserInfoLoading = false));
        }
      });
    },
    isEditPwd() {
      this.dgIsEditPwd = true;
    },
  },
  computed: {

  },
};
</script>
